import { IGenerateSessionResponse } from '../../models/responses/video-verification-response'

export const SET_GENERATE_SESSION_PARAMS = "SET_GENERATE_SESSION_PARAMS";


export interface GenerateSessionParamsAction {
  type: typeof SET_GENERATE_SESSION_PARAMS;
  payload: IGenerateSessionResponse;
}


export type VideoVerificationActions =
  | GenerateSessionParamsAction
